import { combineReducers } from "redux";
import response from "./request";
import loading from "./loading";
import signin from "./signin";
import forgot from "./forgot";

export default combineReducers({ 
  signin,
  forgot,
  response,
  loading
});



// WEBPACK FOOTER //
// ./src/reducers/index.js